import { PageType } from "shared/lib/page-type";

import type { AdUnit } from "./types";

export const Tier1AdSlotWaitingTime = 40; // ms
export const Tier1AdSlotDeadline = 200; // ms

export const Tier2AdSlotWaitingTime = 100; // ms
export const Tier2AdSlotDeadline = 500; // ms

export const Tier3AdSlotWaitingTime = 200; // ms
export const Tier3AdSlotDeadline = 1000; // ms

export const Tier1AdSlots = {
  [PageType.Article]: new Set<AdUnit>([
    "d_banner1",
    "d_lrec1",
    "d_lrec2",
    "m_banner1",
    "m_banner3",
    "m_lrec1",
    "outstream1",
  ]),
  [PageType.Homepage]: new Set<AdUnit>([
    "d_banner1",
    "d_banner3",
    "d_lrec1",
    "d_lrec3",
    "hpto1",
    "m_banner1",
    "m_banner3",
    "m_lrec1",
    "m_native2c",
  ]),
  [PageType.Section]: new Set<AdUnit>([
    "d_banner1",
    "d_lrec1",
    "d_lrec3",
    "m_banner1",
    "m_banner3",
    "m_lrec1",
    "m_native2a",
  ]),
  [PageType.SubSection]: new Set<AdUnit>([
    "d_banner1",
    "d_lrec1",
    "d_lrec3",
    "m_banner1",
    "m_banner3",
    "m_lrec1",
    "m_native2a",
  ]),
  [PageType.Topic]: new Set<AdUnit>([
    "d_banner1",
    "d_lrec1",
    "d_lrec3",
    "m_banner1",
    "m_banner3",
    "m_lrec1",
    "m_native2a",
  ]),
} as Record<PageType, Set<AdUnit>>;

export const Tier2AdSlots = {
  [PageType.Article]: new Set<AdUnit>([
    "d_native2b",
    "d_native2d",
    "d_native2e",
    "d_native5",
    "m_lrec2",
    "m_lrec4d",
    "m_lrec4e",
    "m_lrec4f",
    "m_native2b",
    "m_native2d",
    "m_native2e",
    "m_native5",
    "native4",
  ]),
  [PageType.Homepage]: new Set<AdUnit>([
    "d_lrec2",
    "d_lrec3a",
    "d_lrec4",
    "d_lrec4a",
    "d_lrec4b",
    "d_lrec4d",
    "d_native2c",
    "m_lrec2",
    "m_lrec3",
    "m_lrec3c",
    "m_lrec3g",
    "m_lrec3h",
  ]),
  [PageType.Section]: new Set<AdUnit>([
    "d_lrec2",
    "d_lrec3a",
    "d_lrec4",
    "d_lrec4a",
    "d_native2a",
    "d_native2c",
    "m_lrec2",
    "m_lrec3",
    "m_lrec4a",
    "m_native2c",
  ]),
  [PageType.SubSection]: new Set<AdUnit>([
    "d_lrec2",
    "d_lrec3a",
    "d_lrec4",
    "d_lrec4a",
    "d_native2a",
    "d_native2c",
    "m_lrec2",
    "m_lrec3",
    "m_lrec4a",
    "m_native2c",
  ]),
  [PageType.Topic]: new Set<AdUnit>([
    "d_lrec2",
    "d_lrec3a",
    "d_native2a",
    "d_native2c",
    "m_lrec2",
    "m_lrec3",
    "m_native2c",
  ]),
} as Record<PageType, Set<AdUnit>>;
